import { Action, Module, Mutation, VuexModule } from 'vuex-module-decorators';
import { Filter as FilterDto } from '@/domain/interface/Filter';

@Module({ namespaced: true })
class Filter extends VuexModule {
  private readonly defaultFilter: FilterDto = {
    gemeente: [],
    adresId: [],
    gebouwId: [],
    gebouweenheidId: [],
    activiteitType: [],
    datumActiviteit: {
      van: null,
      tot: null,
    },
    indiendatum: {
      van: null,
      tot: null,
    },
    erkenningsnummers: [],
    ondernemingsnummer: [],
    naam: [],
    voornaam: [],
    status: [],
    postcode: null,
    straatnaam: null,
    huisnummer: null,
    busnummer: null,
    meldingsnummer: null,
  };

  private filter = JSON.parse(JSON.stringify(this.defaultFilter));

  @Mutation
  private setFilter(filter: FilterDto): void {
    this.filter = filter;
  }

  @Action
  public updateFilter(filter: FilterDto): void {
    this.context.commit('setFilter', filter);
  }

  @Action
  public resetFilter(): void {
    this.context.commit('setFilter', {
      ...this.defaultFilter,
      datumActiviteit: { van: null, tot: null },
      indiendatum: { van: null, tot: null },
    });
  }

  get getFilter(): FilterDto {
    return this.filter;
  }
}

export default Filter;
